$.eachComponent('select[name*="prices"]', function() {
    $('select[name*="prices"]').each(function() {
        if($(this).attr("main") === "true") {
            $(this).css("visibility", "hidden");    // zneviditelneni volby ceny (pevna/prepoctem) pro hlavni menu
        }
    });    
});